import React, { useEffect, useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Backdrop } from "@mui/material";
import FilterIcon from "../../assets/icons/filterIcon.svg";
import vmsfiltericon from "../../assets/icons/vmsfilterIcon.svg";
import MoreIcon from "../../assets/icons/moreiconRed.svg";
import ViewIcon from "../../assets/images/view1x.png";
import ConnectIcon from "../../assets/images/connect1x.png";
import ConnectPopupIcon from "../../assets/images/Connectpop1x.png";

import RejectIcon from "../../assets/icons/reject.svg";
import RejectPopupIcon from "../../assets/icons/rejectPopup.svg";
import GridViewIcon from "../../assets/icons/gridviewIcon.svg";
import ListViewIcon from "../../assets/icons/listviewIcon.svg";
import {
  MenteeType,
  MenteesType,
  VolunteerType,
  VolunteersType,
  selectedTheme,
  tenants,
  user,
} from "../../utils/constant";
import {
  getMyMentees,
  getMyReqMentees,
  mentorAcceptReq,
  updateUserList,
} from "../../services/userList";
import { myMenteeColumns, myReqMenteeColumns } from "../../utils/tableFields";
import {
  requestStatusColor,
  requestStatusTextForFollowRequest,
} from "../../utils/constant";
import { Button } from "../../shared";
import Tickmark from "../../assets/icon_components/Tickmark";
import MuiModal from "../../shared/Modal";
import { requestPageBreadcrumbs } from "../Breadcrumbs/BreadcrumbsCommonData";
import { formatTableNullValues, useDebounce } from "../../utils";
import CloseIcon from "../../assets/icon_components/general/CloseIcon";
import DataGridSkeleton from "../../shared/Skeleton/CommonSkeleton/DataGridSkeleton";
import MuiTooltipWrapper from "../Tooltip/Tooltip";
import { useWindowSize } from "../../utils/windowResize";
import { SearchBox } from "../../shared/SearchBox";
import { DataGrid } from "@mui/x-data-grid";

export const Mentees = () => {
  const { width } = useWindowSize();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const state = useLocation()?.state;
  const [reason, setReason] = useState("");
  const [reasonError, setReasonError] = React.useState(false);
  const [searchParams] = useSearchParams();
  const [menteeListFormatted, setMenteeListFormatted] = React.useState([]);
  const dispatch = useDispatch();
  const [viewType, setViewType] = useState("table");
  const { menteeList, loading, status } = useSelector(
    (state) => state.userList
  );
   const userinfo =  useSelector((state)=>state.userInfo);
   const role = userinfo?.data?.role
  // State for filter popup
  const [filterPopup, setFilterPopup] = useState({
    show: false,
    selectedItem: "",
  });

  React.useEffect(() => {
    if (menteeList?.results) {
      const formattedMenteeList = formatTableNullValues(menteeList?.results);
      setMenteeListFormatted(formattedMenteeList);
    }
  }, [menteeList?.results]);

  const breadcrumbsStatusType = searchParams.get("status") || "";
  const [mentorType, setMentorType] = useState(
    state?.type === "new_req_mentee"
      ? "new-request-mentees"
      : searchParams.get("req") === "new-request-mentees"
      ? "new-request-mentees"
      : "my-mentee"
  );
  const [requestTab, setRequestTab] = useState(breadcrumbsStatusType || "all");
  const [selectedMentee, setSelectedMentee] = useState({});
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10,
  });
  const [confirmation, setConfirmation] = React.useState({
    bool: false,
    activity: false,
    type: "",
    id: "",
  });
  const [search, setSearch] = React.useState("");
  const debouncedSearchTerm = useDebounce(search, 500);

  const menteeOption = [
    {
      name: (
        <MuiTooltipWrapper title={`List of ${role === user.mentor ?  MenteesType : VolunteersType} assigned to you`}>
          <span>{`My ${role === user.mentor ?  MenteesType : VolunteersType}`}</span>
        </MuiTooltipWrapper>
      ),
      value: "my-mentee",
    },
    // {
    //   name: "Follow Requests",
    //   value: "new-request-mentees",
    // },
  ];

  const requestBtns = [
    {
      name: "All",
      key: "all",
    },
    {
      name: "New",
      key: "new",
    },
    {
      name: "Pending",
      key: "pending",
    },
    {
      name: "Connect",
      key: "accept",
    },
    {
      name: "Reject",
      key: "cancel",
    },
  ];

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event, data) => {
    setAnchorEl(event.currentTarget);
    setSelectedMentee(data);
  };

  const handleConnectionReq = (id, status) => {
    const payload = {
      follow_id: id,
      status: status,
    };
    if (reason) {
      payload.cancelled_reason = reason;
    }
    dispatch(mentorAcceptReq(payload));
  };

  React.useEffect(() => {
    if (status === "done") {
      setConfirmation({
        ...confirmation,
        activity: false,
        bool: true,
      });
      setReason("");
      setTimeout(() => {
        closeConfirmation();
        getTableData();
        dispatch(updateUserList({ status: "" }));
      }, [2000]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const handleStatusFilterClick = (e) => {
    e.stopPropagation();
    setFilterPopup({
      ...filterPopup,
      show: true,
      selectedItem: requestTab,
    });
  };

  const handleSelectOption = (key) => {
    setFilterPopup({
      ...filterPopup,
      selectedItem: key,
    });
  };

  const handleApplyFilter = () => {
    setRequestTab(filterPopup.selectedItem);
    setPaginationModel({
      page: 0,
      pageSize: 10,
    });
    setFilterPopup({
      ...filterPopup,
      show: false,
    });
  };

  const myMenteeColumn = [
    ...myMenteeColumns((user)=>userNavigate(
                    user?.id,
                    requestPageBreadcrumbs.myMentee
                  )),
    // {
    //   field: "action",
    //   headerName: "Action",
    //   flex: 1,
    //   id: 4,
    //   headerAlign: "center",
    //   renderCell: (params) => {
    //     return (
    //       <>
    //         <div className="cursor-pointer mt-4 flex justify-center">
    //           <img
    //             src={EyeIcon}
    //             onClick={() => {
    //               userNavigate(
    //                 params?.row?.id,
    //                 requestPageBreadcrumbs.myMentee
    //               );
    //             }}
    //             alt={"ViewIcon"}
    //           />
    //         </div>
    //       </>
    //     );
    //   },
    // },
  ];

  const myReqMenteeColumn = [
    ...myReqMenteeColumns,
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
      id: 2,
      renderCell: (params) => {
        return (
          <>
            <div className="cursor-pointer flex items-center h-full relative">
              <span
                className="w-[80px] flex justify-center h-[30px] px-3"
                style={{
                  background:
                    requestStatusColor[params.row.status]?.bgColor || "",
                  lineHeight: "30px",
                  borderRadius: "3px",
                  width: "110px",
                  height: "34px",
                  color: requestStatusColor[params.row.status]?.color || "",
                  fontSize: "12px",
                }}
              >
                {requestStatusTextForFollowRequest[params.row.status]}
              </span>
            </div>
          </>
        );
      },
      renderHeader: (params) => (
        <div className="flex items-center gap-1">
          <span className="font-semibold">Status</span>
          <img
            src={selectedTheme === "vms" ? vmsfiltericon : FilterIcon}
            alt="Filter"
            className="w-4 h-4 cursor-pointer pt-1"
            onClick={handleStatusFilterClick}
          />
        </div>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      id: 4,
      renderCell: (params) => {
        return (
          <>
            <div className="w-full h-full flex items-center justify-center">
              <div
                className="cursor-pointer w-8 h-8 rounded-full flex items-center justify-center bg-gray-200 hover:bg-gray-300 transition-all duration-300"
                onClick={(e) => handleClick(e, params.row)}
              >
                <img src={MoreIcon} alt="MoreIcon" />
              </div>
            </div>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              slotProps={{
                paper: {
                  sx: {
                    boxShadow: "0px 1px 2px rgba(0,0,0,0.2)",
                    overflow: "visible",
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      left: "45%",
                      height: 10,
                      width: 10,
                      backgroundColor: "inherit",
                      zIndex: -1,
                      marginLeft: "0.5px",
                      transform: "translateY(-50%) rotate(45deg)",
                      boxShadow: "0px 0px 2px rgba(0,0,0,0.2)",
                    },
                  },
                },
              }}
            >
              <MenuItem
                onClick={() =>
                  navigate(
                    `/profileView?breadcrumbsType=${requestPageBreadcrumbs.newFollowRequest}&status=${requestTab}`,
                    {
                      state: {
                        row_id: selectedMentee?.id,
                        user_id: selectedMentee?.follower,
                        is_approved: selectedMentee?.is_approved,
                        status: selectedMentee?.status,
                        rejection_reason: selectedMentee?.cancelled_reason,
                      },
                    }
                  )
                }
                className="!text-[12px]"
              >
                <img src={ViewIcon} alt="ViewIcon" className="pr-3 w-[30px]" />
                View
              </MenuItem>
              {(selectedMentee?.status === "new" ||
                selectedMentee?.status === "cancel" ||
                selectedMentee?.status === "pending") && (
                <MenuItem
                  onClick={() =>
                    handleOpenActivityPopup(selectedMentee?.id, "accept")
                  }
                  className="!text-[12px]"
                >
                  <img
                    src={ConnectIcon}
                    alt="ViewIcon"
                    className="pr-3 w-[30px]"
                  />
                  Connect
                </MenuItem>
              )}
              {(selectedMentee?.status === "new" ||
                selectedMentee?.status === "accept" ||
                selectedMentee?.status === "pending") && (
                <MenuItem
                  onClick={() =>
                    handleOpenActivityPopup(selectedMentee?.id, "reject")
                  }
                  className="!text-[12px]"
                >
                  <img
                    src={RejectIcon}
                    alt="ViewIcon"
                    className="pr-3 w-[30px]"
                  />
                  Reject
                </MenuItem>
              )}
            </Menu>
          </>
        );
      },
    },
  ];

  const title =
    menteeOption.find((option) => option.value === mentorType)?.name || "";

  // const handleTab = (key) => {
  //   setPaginationModel({
  //     page: 0,
  //     pageSize: 10,
  //   });
  //   setRequestTab(key);
  // };

  const getTableData = (search = "") => {
    if (mentorType === "my-mentee") {
      dispatch(
        getMyMentees({
          page: paginationModel?.page + 1,
          limit: paginationModel?.pageSize,
          search: search,
        })
      );
    } else {
      dispatch(
        getMyReqMentees({
          page: paginationModel?.page + 1,
          limit: paginationModel?.pageSize,
          search: search,
          status: requestTab,
        })
      );
    }
  };

  useEffect(() => {
    getTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationModel, mentorType, requestTab]);
  useEffect(() => {
    if (searchParams.get("req")) {
      setMentorType(searchParams.get("req"));
    }
  }, [searchParams]);
  useEffect(() => {
    if (breadcrumbsStatusType) {
      setRequestTab(breadcrumbsStatusType);
    }
  }, [breadcrumbsStatusType]);

  const handleOpenActivityPopup = (id, type) => {
    handleClose();
    setConfirmation({
      ...confirmation,
      activity: true,
      type: type,
      id: id,
    });
  };

  const handleConfirmBtn = (e) => {
    if (e) e.preventDefault();
    if (confirmation?.type === "reject" && !reason.trim()) {
      setReasonError(true);
      return;
    }
    setReasonError(false);
    handleConnectionReq(confirmation?.id, confirmation?.type);
  };

  const closeConfirmation = () => {
    handleClose();
    setConfirmation({
      ...confirmation,
      bool: false,
      activity: false,
      type: "",
      id: "",
    });
    setReason("");
  };

  const handleViewChange = () => {
    setViewType(viewType === "table" ? "card" : "table");
  };

  const handleSearch = (searchText) => {
    setSearch(searchText);
  };

  useEffect(() => {
    getTableData(debouncedSearchTerm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm]);

  const userNavigate = (id, breadcrumbs = "", fromType = "") => {
    if (selectedTheme === tenants.LCA) {
      navigate(
        `/user/${id}?role=mentee${
          breadcrumbs && `&breadcrumbsType=${breadcrumbs}`
        }`
      );
    } else {
      navigate(
        `/mentor-details/${id}?type=view${
          breadcrumbs && `&breadcrumbsType=${breadcrumbs}`
        }${fromType && `&fromType=${fromType}`}`
      );
    }
  };

  return (
    <div className="px-2 py-9 sm:px-2 md:px-4 lg:px-9 xl:px-9">
      {/* <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
      <div
        className="px-0 py-5 sm:px-0 md:px-1 lg:px-3 xl:px-3"
        style={{ boxShadow: "4px 4px 25px 0px rgba(0, 0, 0, 0.15)" }}
      >
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center px-4 sm:px-5 pb-4 mb-8 border-b-2 gap-4">
          {/* Left Section */}
          <div className="flex flex-wrap items-center gap-3 sm:gap-5">
            <p className="text-base font-medium">{title}</p>

            {mentorType === "my-mentee" && (
              <img
                src={viewType === "table" ? ListViewIcon : GridViewIcon}
                className="cursor-pointer w-5 h-5"
                alt="view icon"
                onClick={handleViewChange}
              />
            )}

            {/* Placeholder for Filter Icon or other elements */}
            {/* <img src={FilterIcon} alt="Filter Icon" /> */}
          </div>

          {/* Right Section */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4 md:gap-6 w-full md:w-auto">
            <div className="relative w-full sm:w-auto">
              <SearchBox
                height="42px"
                width="100%"
                title={
                  width < 1024 ? "Search" : `Search ${role === user.mentor ?  MenteeType : VolunteerType} Name/ Email`
                }
                animatedItems={[
                  `${role === user.mentor ?  MenteeType : VolunteerType} Name`,
                  `${role === user.mentor ?  MenteeType : VolunteerType} Email`
                ]}
                enableAnimation={true}
                handleSearch={(e) => handleSearch(e)}
                value={search}
              />
            </div>

            {/* Optional Dropdown (if needed later) */}
            {/* 
        <Dropdown
          label={"My Mentee"}
          options={menteeOption}
          value={mentorType}
          handleDropdown={(event) => {
            setMentorType(event.target.value);
            navigate(`/mentees?req=${event.target.value}`);
            setViewType("table");
          }}
        />
        */}
          </div>
        </div>

        <div className="mx-5">
          {loading ? (
            <DataGridSkeleton />
          ) : viewType === "table" ? (
            <DataGrid
              rows={menteeListFormatted ?? []}
              columns={
                mentorType === "my-mentee" ? myMenteeColumn : myReqMenteeColumn
              }
              paginationMode="server"
              pagination
              disableColumnMenu={true}
              disableColumnSorting={true}
              rowCount={menteeList?.count}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
            />
          ) : null}

          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={confirmation?.activity && confirmation?.type !== "reject"}
          >
            <div className="popup-content w-2/6 md:w-2/4 sm:w-2/4 bg-white flex flex-col gap-2 h-[330px] justify-center items-center">
              <img
                src={
                  confirmation?.type === "reject"
                    ? RejectPopupIcon
                    : ConnectPopupIcon
                }
                alt="ConnectIcon"
              />
              <span
                style={{ color: "#232323", fontWeight: 600, fontSize: "24px" }}
              >
                {confirmation?.type === "reject" ? "Reject" : "Connect"}
              </span>
              <div></div>
              <div className="py-5">
                <p
                  style={{
                    color: "rgba(24, 40, 61, 1)",
                    fontWeight: 600,
                    fontSize: "18px",
                  }}
                >
                  Are you sure you want to
                  <span>
                    {" "}
                    {confirmation?.type === "reject" ? "reject" : "follow"}{" "}
                  </span>
                  {MenteeType}?
                </p>
              </div>
              <div className="flex justify-center p-4">
                <div className="flex gap-6 justify-center align-middle">
                  <Button
                    btnName="Cancel"
                    btnCategory="secondary"
                    onClick={() => closeConfirmation()}
                  />
                  <Button
                    btnType="button"
                    btnCls="w-[110px] !bg-[#E0382D] border !border-[#E0382D] !text-[#fff]"
                    btnName={
                      confirmation?.type === "reject" ? "Reject" : "Connect"
                    }
                    btnCategory={
                      confirmation?.type === "reject" ? "" : "primary"
                    }
                    onClick={() => handleConfirmBtn()}
                  />
                </div>
              </div>
            </div>
          </Backdrop>

          <MuiModal
            modalSize="md"
            modalOpen={
              confirmation?.activity && confirmation?.type === "reject"
            }
            modalClose={closeConfirmation}
            noheader
          >
            <div className="px-5 py-5">
              <div
                className="flex justify-center flex-col gap-5 mt-4 mb-4"
                style={{
                  border: "1px solid rgba(29, 91, 191, 1)",
                  borderRadius: "10px",
                }}
              >
                <div
                  className="flex justify-between px-3 py-4 items-center"
                  style={{ borderBottom: "1px solid rgba(29, 91, 191, 1)" }}
                >
                  <p
                    className="text-[18px]"
                    style={{ color: "rgba(0, 0, 0, 1)" }}
                  >
                    Reject Request Reason{" "}
                  </p>
                  <CloseIcon
                    className="cursor-pointer"
                    onClick={closeConfirmation}
                  />
                </div>
                <div className="px-5">
                  <form onSubmit={handleConfirmBtn}>
                    <div className="relative pb-8">
                      <label className="block tracking-wide text-gray-700 text-xs font-bold mb-2">
                        Reject Reason{" "}
                        <span style={{ color: "red" }}>{"*"}</span>
                      </label>
                      <div className="relative">
                        <textarea
                          value={reason}
                          onChange={(e) => {
                            setReason(e.target.value);
                            setReasonError(false);
                          }}
                          id="message"
                          rows="4"
                          className={`block p-2.5 input-bg  text-sm 
                               focus-visible:outline-none focus-visible:border-none !border !border-[#E50027] w-[100%] !text-[#18283D] h-[130px]`}
                          placeholder={""}
                        ></textarea>
                        {reasonError && (
                          <p className="text-red-500 text-xs mt-1">
                            Please provide a reason for rejection.
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="flex justify-center gap-5 items-center pt-5 pb-10">
                      <Button
                        btnName="Cancel"
                        btnCls="w-[18%]"
                        btnCategory="secondary"
                        onClick={closeConfirmation}
                      />
                      <button
                        type="submit"
                        className={`text-white py-3 px-7 w-[18%] rounded-[3px] ${
                          selectedTheme === tenants.VMS
                            ? "bg-background-primary-main"
                            : "bg-right-gradient"
                        }`}
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </MuiModal>

          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={confirmation?.bool}
            onClick={() => closeConfirmation()}
          >
            <div className="px-5 py-1 flex justify-center items-center">
              <div
                className="flex justify-center items-center flex-col gap-[2.25rem] py-[4rem] px-[3rem] mt-20 mb-20"
                style={{ background: "#fff", borderRadius: "10px" }}
              >
                <Tickmark />
                <p
                  className={`text-[16px] font-semibold bg-clip-text text-transparent ${
                    selectedTheme === tenants.MMA
                      ? "bg-right-gradient"
                      : "bg-background-primary-main"
                  }`}
                  style={{ fontWeight: 600 }}
                >
                  {confirmation?.type === "accept" &&
                    `${MenteeType} has been successfully connected`}
                  {confirmation?.type === "reject" &&
                    `${MenteeType} has been successfully deleted`}
                </p>
              </div>
            </div>
          </Backdrop>

          {/* Filter Popup for Status */}
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={filterPopup.show}
          >
            <div className="py-3 px-4 bg-white" style={{ borderRadius: "3px" }}>
              <div className="py-5 px-5 border border-background-primary-main rounded-[3px]">
                <div className="flex justify-between mb-4">
                  <h3 className="text-base text-black font-medium">
                    Filter Status
                  </h3>
                  <CloseIcon
                    className="cursor-pointer"
                    onClick={() =>
                      setFilterPopup({
                        ...filterPopup,
                        show: false,
                        selectedItem: "",
                      })
                    }
                  />
                </div>
                <div className="text-black">
                  <ul
                    className="py-3 leading-10"
                    style={{
                      margin: "10px 0px 20px 0",
                    }}
                  >
                    {requestBtns.map((option, index) => (
                      <li key={index} className="flex gap-7 items-center">
                        <input
                          type="checkbox"
                          className="w-[20px]"
                          checked={filterPopup.selectedItem === option.key}
                          onChange={() => handleSelectOption(option.key)}
                          value={option.key}
                        />
                        <span className="text-[16px]">{option.name}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="flex gap-6 justify-center align-middle">
                    <Button
                      btnName="Cancel"
                      btnCategory="secondary"
                      onClick={() =>
                        setFilterPopup({
                          ...filterPopup,
                          show: false,
                          selectedItem: "",
                        })
                      }
                    />
                    <Button
                      btnType="button"
                      btnCls="w-[100px]"
                      onClick={handleApplyFilter}
                      btnName={"Ok"}
                      btnCategory="primary"
                      className="bg-background-primary-main"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Backdrop>
        </div>
      </div>
    </div>
  );
};
